var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"divChart",staticClass:"ig-distribuicao-chart"},[_c('apexchart',{ref:`igDistribuicao-${_vm.igId}`,attrs:{"height":`${_vm.showBtn ? 'auto' : '180'}`,"type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }